import React, { Component } from "react";
import UpdateUserProfile from "./UpdateUserProfile";
import { UserProfileActions } from "../../../../store/userProfile";
import { connect } from "react-redux";
import withAppShell from "../../../hoc/withAppShell/WithAppShell";
import lodashUtil from 'lodash'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'

class UpdateUserProfileContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentWillMount() {
    let i18n;
    if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
      i18n = getKeyFromLS("i18n");
    } else {
      i18n = this.props.i18n
    }
    this.setState({
      i18n: i18n
    })
  }
  render() {
    return <UpdateUserProfile {...this.props} {...this.state} />;
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateUserProfile: (user) => dispatch(UserProfileActions.updateUserProfile(user))
  };
};

const mapStateToProps = state => {
  return {
    //user: state.UpdateUserProfile.user,
    activeSchool: state.schoolInformation.activeSchool,
    userInformation: state.userProfile.userInformation,
    i18n: state.i18nMessages.i18n
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAppShell(UpdateUserProfileContainer));
